import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ms-2" }
const _hoisted_2 = { key: 1 }

import { PropType } from 'vue';
import { Rating } from '../../../shared/app/models/index.js';
import { glicko2Settings, isRatingConfident } from '../../../shared/app/ratingUtils.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTablePlayerRating',
  props: {
    rating: {
        type: Object as PropType<Rating>,
        default: null,
    },
},
  setup(__props) {



const { round } = Math;

return (_ctx: any,_cache: any) => {
  return (__props.rating)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass({ 'text-secondary': !_unref(isRatingConfident)(__props.rating) })
      }, [
        _createTextVNode(_toDisplayString(_unref(round)(__props.rating.rating)) + " ", 1),
        _createElementVNode("small", _hoisted_1, "±" + _toDisplayString(_unref(round)((__props.rating.deviation ?? _unref(glicko2Settings).rd) * 2)), 1)
      ], 2))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
}
}

})